import { Text, styled } from '@chilipiper/design-system'

export const StyledReply = styled(Text)`
  box-shadow: inset 0 0 0 1px rgb(var(--primary-color));
  background-color: transparent;
  color: rgb(var(--primary-color));
  text-align: left;
  border-radius: 16px;
  cursor: pointer;
  border: none;
  user-select: none;
  appearance: none;
  transition: all 0.15s ease-in-out;

  &[disabled] {
    cursor: auto;
  }

  &[disabled],
  &:hover {
    background-color: rgb(var(--primary-color));
    color: rgb(var(--primary-contrast-color));
  }
`
